import {typeExport} from "../../../../../redux/store/type";

const reducerUploadDocumentSatiaScreen = (state = { NoInternetDialog: false, results: null ,  isLoading:false, TypeDocumentsList:[]}, action) => {
    switch (action.type) {
        case typeExport.UploadDocumentSatiaScreen_SERVICE_PENDING:
            return Object.assign({}, state, {
                NoInternetDialog: false,
                isLoading:true ,
                results:null
            });
        case typeExport.UploadDocumentSatiaScreen_SERVICE_ERROR:
            return Object.assign({}, state, {
                NoInternetDialog: true,
                isLoading:false ,
                error: action.error
            });
        case typeExport.UploadDocumentSatiaScreen_SERVICE_SUCCESS:
            return Object.assign({}, state, {
                results: action.results,
                NoInternetDialog: false ,
                isLoading:false ,
                TypeDocumentsList: action.TypeDocumentsList,

            });

            case typeExport.UploadDocumentSatiaScreen_SERVICE_REFRESH:
            return Object.assign({}, state, {
                results: action.results,
                NoInternetDialog: false ,
                isLoading:false ,
            });

        default:
            return state;
    }
}

export default reducerUploadDocumentSatiaScreen;
